import { render, staticRenderFns } from "./Addition.vue?vue&type=template&id=0f63f858&scoped=true&"
import script from "./Addition.vue?vue&type=script&lang=ts&"
export * from "./Addition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f63f858",
  null
  
)

export default component.exports